<template>
    <v-row  >
        <v-col>
            <b>Services</b>
            <v-row  class="mt-2">
                <v-col cols="12" md="8" lg="8">
                    The full estimated cost of these services:
                    <b v-if="totalPrice > 0">{{ totalPrice | currency}}</b>
                    <span class="no-services" v-else>select services</span>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="9" md="6">
                    <v-text-field
                            v-model="titleOrCodeFilter"
                            label="Search by title/code"
                    ></v-text-field>
                </v-col>
                <v-col md="6" cols="3">
                    <v-checkbox v-model="selectedFirst" label="Selected at the top"></v-checkbox>
                </v-col>
            </v-row>
        </v-col>
        <v-col lg="12" md="12" cols="12">
            <table class="v-table theme--light">
                <thead>
                <tr>
                    <th></th>
                    <th>Title</th>
                    <th>Code</th>
                    <th style="width: 150px;">Price</th>
                    <th width="150">Quantity</th>
                </tr>
                </thead>
                <tbody v-if="!noServices">
                <tr v-for="resultService in sortedResultServices"
                    v-bind:key="resultService.id">
                    <td>
                        <v-checkbox :disabled="readOnly" v-model="resultService.added"
                                    @change="e => {handleChangeCheckbox(resultService.id, e)}"></v-checkbox>
                    </td>
                    <td>
                        <div class="mb-2">{{resultService.title}}</div>
                    </td>
                    <td>
                        <div class="mb-2">{{resultService.code}}</div>
                    </td>
                    <td>
                        <div class="mb-2">{{resultService.price | currency}}</div>
                    </td>
                    <td>
                        <v-select
                                :disabled="readOnly"
                                v-if="resultService.quantity"
                                :value="resultService.quantity || 1"
                                :items="quantityOptions"
                                @change="e => {handleQuantityChange(resultService.id, e)}"
                        ></v-select>
                    </td>
                </tr>
                </tbody>
                <tbody v-if="noServices">
                <tr>
                    <td colspan="5" class="text-center">Client has no available services. Please add services to
                        client first.
                    </td>
                </tr>
                </tbody>
            </table>
        </v-col>
    </v-row>
</template>

<script>
    import {mapState} from 'vuex';
    import _ from 'lodash'
    import NoEmpty from '../../Filters/NoEmpty'

    export default {
        name: 'services',
        props: {
            clientId: String,
            selectedServices: {
                Type: Array
            },
            readOnly: {
                Type: Boolean
            }
        },
        filters: {NoEmpty},
        data() {
            return {
                service: null,
                menu: {},
                quantityOptions: _.range(1, 51),
                filters: {
                    titleOrCode: '',
                },
                selectedFirst: false
            }
        },
        computed: {
            ...mapState('services', {
                availableServicesById: 'servicesById',
                clientServicesByClientId: 'clientServicesByClientId'
            }),
            noServices() {
                return this.availableServicesForClient.length === 0
            },
            availableServicesForClient() {
                if (!this.clientId) {
                    return []
                }

                const servicesByClient = this.clientServicesByClientId[this.clientId] || {}

                let resultServices = []
                for (let serviceId in servicesByClient) {
                    if (!this.availableServicesById.hasOwnProperty(serviceId)) {
                        continue
                    }

                    const service = this.availableServicesById[serviceId]

                    if (!service) {
                        continue
                    }

                    resultServices.push({
                        ...service,
                        price: servicesByClient[serviceId].price,
                        currency: servicesByClient[serviceId].currency,
                    })
                }
                return resultServices
            },
            titleOrCodeFilter: {
                get() {
                    return this.filters.titleOrCode
                },
                set: _.debounce(function (value) {
                    this.filters.titleOrCode = value
                }, 500),
            },
            totalPrice() {
                let total = 0
                for (let resultService of this.resultServices) {
                    if (!resultService.added) {
                        continue
                    }

                    total += resultService.price * resultService.quantity
                }

                return total
            },
            resultServices() {
                let services = []

                for (let availableService of this.availableServicesForClient) {
                    let item = {
                        id: availableService.id,
                        title: availableService.title,
                        code: availableService.code,
                        price: availableService.price,
                        currency: availableService.currency,
                        quantity: null,
                        added: false
                    }

                    const selectedServicesById = _.keyBy(this.selectedServices, 'serviceId')

                    let caseService = selectedServicesById[availableService.id]
                    if (caseService) {
                        item.added = true
                        item.quantity = caseService.quantity
                    }

                    services.push(item)
                }

                return services
            },
            filteredByTitleOrCodeResultServices() {
                let titleOrCodeKeyword = _.get(this.filters, 'titleOrCode', '')
                if (titleOrCodeKeyword === '') {
                    return this.resultServices
                }

                return _.filter(this.resultServices, function (item) {
                    let titleResult = _.toLower(item.title).indexOf(_.toLower(titleOrCodeKeyword))

                    if (titleResult >= 0) {
                        return true
                    }

                    return item.code.includes(titleOrCodeKeyword)
                })
            },
            sortedResultServices() {
                if (!this.selectedFirst) {
                    return _.orderBy(this.filteredByTitleOrCodeResultServices, ['code'], ['asc'])
                }

                return _.orderBy(this.filteredByTitleOrCodeResultServices, ['added', 'code'], ['desc', 'asc'])
            },
        },
        methods: {
            handleQuantityChange(id, newValue) {
                this.$emit('changeQuantity', {serviceId: id, quantity: newValue})
            },
            handleChangeCheckbox(id, newValue) {
                if (newValue) {
                    this.$emit('addService', id)
                    return
                }

                this.$emit('removeService', id)
            },
        }

    }
</script>

<style>
    .no-services {
        color: rgba(0, 0, 0, .54);
    }
</style>